import * as React from 'react';
import { useContext, useState } from 'react';
import { AuthContext } from '../_auth/AuthContext';
import { Typography, IconButton } from '@material-ui/core';
import EquipmentDisplayItem from './_equipment_display';
import InterfaceDisplayItem from './_interface_display';
import { useParams } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import { Grid } from '@material-ui/core';
import { GetEquipmentInterface, DefaultManifest, GetLocation, SaveEquipment, SaveInterface } from '../_service/location';
import { IEquipmentManifest, IEquipment, IInterface, INayaxConfig } from '../_types/location';
import { useHistory } from 'react-router-dom';
import Icon, { SupportedIcons } from '../common/Icon';
import { DeleteEquipment, DeleteInterface } from '../_service/location';
import AlertDialog from '../common/AlertDialog';

interface Props {

};

const useStyles = makeStyles((theme) => ({
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
    },
    selectEmpty: {
        marginTop: theme.spacing(2)
    },
    header: {
        marginBottom: theme.spacing(1),
        marginTop: theme.spacing(1)
    }
}));

const Equipment: React.FC<Props> = (prop: Props) => {

    const { user, setUser } = useContext(AuthContext);
    const [equip, setEquip] = useState<IEquipmentManifest>(DefaultManifest);
    const [openAlert, setOpenAlert] = useState<boolean>(false);
    const [alertText, setAlertText] = useState<string>('');

    const classes = useStyles();
    let { id } = useParams<any>();
    const history = useHistory();


    const loadEquipment = (id: number) => {

        GetEquipmentInterface(id).then(d => {
            setEquip(d); 
        
        });
    }

    React.useEffect(() => {
        if (user.currentLocation) {
            loadEquipment(user.currentLocation.id);
        }
    }, [user]);
    

    React.useEffect(() => {
        let currentUser = user;
        if (!currentUser.currentLocation) {
            
            if (id) {
                if (currentUser.locations) {
                    let loc = currentUser.locations.find(g => g.id === id);
                    if (loc)  {
                        user.currentLocation = loc;
                        setUser({...currentUser});
                    }

                    

                    if (user.currentLocation) {
                        history.push('/locations/equipment');
                        //loadEquipment(user.currentLocation.id);
                    }
                } else {
                    GetLocation(id).then(d => {
            
                        currentUser.currentLocation = d;    
                        setUser((prv) => { return {...currentUser}; });
                        history.push('/locations/equipment');
                        // loadEquipment(id);
                        
                    });
                    
                }
            }
    
        } else {
            loadEquipment(currentUser.currentLocation.id);
        }
        



    }, []);

    const highLightEquipment = (toHL:number) => {
        //LEARN
        setEquip((prv) => {
            let toSet = prv.equipment.find(g => g.id === toHL);
            if (toSet) {
                let selected = !toSet.selected;
                
                prv.equipment.forEach(e => e.selected = false);
                prv.interfaces.forEach(e => e.selected = false);

                if (selected) {
                    toSet.selected = true;
                    let matchingInterfaces = prv.interfaces.filter(i => i.equipment.filter(e => e.washequipment_id === toHL).length > 0);
                    matchingInterfaces.forEach(element => {
                        element.selected = true;
                    });
                }

            }
            return ({...prv});
        });
    }

    const highLightInterface = (toHL:number) => {
        //LEARN
        setEquip((prv) => {
            let toSet = prv.interfaces.find(g => g.id === toHL);
            if (toSet) {
                let selected = !toSet.selected;

                prv.equipment.forEach(e => e.selected = false);
                prv.interfaces.forEach(e => e.selected = false);

                if (selected) {
                    toSet.selected = true;
                    toSet.equipment.forEach(e => {
                        let iequip = prv.equipment.find(g => g.id === e.washequipment_id);
                        if (iequip) {
                            iequip.selected = true;
                        }
                    });
                }


            }
            return ({...prv});
        });
    }

    const _CancelAddEquipment = () => {

        let inEdit = equip.equipment.find(g => g.editing === true);
        if (inEdit) {
            if (inEdit.id === 0) {
                setEquip(prv => {
                    prv.equipment.shift();
                    prv.equipment.forEach(g => {g.selected = false; g.editing = false; return true;});
                    prv.interfaces.forEach(g => {g.selected = false; g.editing = false; return true;});
                    return {...prv};
                })
            } else {
                //we need to restore from db
                let id = user.currentLocation?.id || 0;
                GetEquipmentInterface(id).then(d => {
                    let idx = equip.equipment.findIndex(g => g.editing === true);
                    let orig = d.equipment.find(g => g.id === inEdit?.id);      
                    setEquip(prv => {
                        prv.equipment.forEach(g => {g.selected = false; g.editing = false});
                        prv.interfaces.forEach(g => {g.selected = false; g.editing = false});      
                        prv.equipment[idx] = orig as IEquipment;
                        return {...prv};
                    })
                    
                });

            }
        }

    }

    const _CancelAddInterface = () => {


        let inEdit = equip.interfaces.find(g => g.editing === true);
        if (inEdit) {
            if (inEdit.id === 0) {
                setEquip(prv => {
                    prv.interfaces.shift();
                    prv.equipment.forEach(g => {g.selected = false; g.editing = false});
                    prv.interfaces.forEach(g => {g.selected = false; g.editing = false});
                    return {...prv};
                })
            } else {
                //we need to restore from db
                let id = user.currentLocation?.id || 0;
                GetEquipmentInterface(id).then(d => {
                    let idx = equip.interfaces.findIndex(g => g.editing === true);
                    let orig = d.interfaces.find(g => g.id === inEdit?.id);      
                    setEquip(prv => {
                        prv.equipment.forEach(g => {g.selected = false; g.editing = false});
                        prv.interfaces.forEach(g => {g.selected = false; g.editing = false});      
                        prv.interfaces[idx] = orig as IInterface;
                        return {...prv};
                    })
                    
                });

            }
        }

    }

    const _SaveEquipment = () => {
        let inEdit = equip.equipment.findIndex(g => g.editing);
        let toSave = equip.equipment[inEdit];

   

        SaveEquipment(toSave).then(e => {
            e.editing = false;
            e.selected = false;
            equip.equipment[inEdit] = e;
          
            setEquip((prv) => {return {...equip}});
        });

    }

    const _DeleteEquipment = async (equipmentId: number | null) => {
        if (!equipmentId) return;

        let response = await DeleteEquipment(equipmentId);

        if (!response) {
            setOpenAlert(true);
            setAlertText("Error deleting equipment.");

            return;
        }

        setEquip(response);
        setAlertText("Equipment deleted.");
        setOpenAlert(true);
    }

    const _DeleteInterface = async (interfaceId: number | null) => {
        if (!interfaceId) return;

        let response = await DeleteInterface(interfaceId);

        if (!response) {
            setOpenAlert(true);
            setAlertText("Error deleting interface.");

            return;
        }

        setEquip(response);
        setAlertText("Interface deleted.");
        setOpenAlert(true);
    }

    const _SaveInterface = () => {
        let inEdit = equip.interfaces.findIndex(g => g.editing);
        let toSave = equip.interfaces[inEdit];

        if (toSave.model && toSave.model.length > 255) {
            setOpenAlert(true);
            setAlertText("Model name is too long.  Please limit to 255 characters.");
            return;
        }

        if (toSave.provider_name === "nayax") {
            if (toSave.equipment.length === 0) {
                setOpenAlert(true);
                setAlertText("Please add equipment before saving a Nayax interface.");
                return;
            }

            let invalidNayaxConfig = toSave.equipment.find(g => {
                if (!g.remote_config) {
                    return true;
                }

                let config: INayaxConfig = JSON.parse(g.remote_config) as INayaxConfig;
                let terminalId = config.TerminalId ? config.TerminalId.trim() : "";
                let uniQR = config.UniQR ? config.UniQR.trim() : "";

                return terminalId.length === 0 && uniQR.length === 0;
            });

            if (invalidNayaxConfig) {
                setOpenAlert(true);
                setAlertText("Nayax requires a Terminal ID or UniQR.");
                return;
            }
        }

        SaveInterface(toSave).then(e => {
            e.editing = false;
            e.selected = false;

            equip.interfaces[inEdit] = e;
            setEquip((prv) => {return {...equip}});
        });

    }

    const _EquipChange = (itm: IEquipment) => {
        setEquip(prv => {
            let inEdit = prv.equipment.findIndex(g => g.editing);
            prv.equipment[inEdit] = { ...prv.equipment[inEdit], ...itm};
            return {...prv};
        })
    }
    const _InterfaceChange = (itm: IInterface) => {
        setEquip(prv => {
            let inEdit = prv.interfaces.findIndex(g => g.editing);
            prv.interfaces[inEdit] = { ...prv.interfaces[inEdit], ...itm};
            return {...prv};
        })
    }

    const _addNewEquipment = () => {
        id = user.currentLocation?.id || 0;
        let uuid:string | null = user.currentLocation?.uuid || null;
        equip.equipment.unshift({
            editing: true,
            service_location_uuid: uuid,
            equipment_type_cn: "equipmenttype.iba",
            name: "new equipment",
            selected: false,
            id: 0,
            service_location_id: id,
            deleted: false,
            enabled: false
        });

        equip.equipment.forEach(g => g.selected = false);
        equip.interfaces.forEach(g => g.selected = false);

        setEquip({...equip});
    }

    const _addNewInterface = () => {
        
        equip.interfaces.unshift({
            deleted:false,
            editing: true,
            equipment: [],
            service_location_id: user.currentLocation?.id as number,
            id: 0,
            interface_type_cn: "interfacetype.unit",
            model: null,
            provider_name: "",
            selected: false,
            service_location_uuid: user.currentLocation?.uuid as string,
            triggers: []
        })

        equip.equipment.forEach(g => g.selected = false);
        equip.interfaces.forEach(g => g.selected = false);

        setEquip({...equip});
    }

    const canAdd = () => {
        return equip.equipment.filter(g => g.editing).length === 0
            && equip.interfaces.filter(g => g.editing).length === 0;
    }

    /*
        Wash Equipment
            type (tunnel, iba, vac, dispensor), name, enabled, manufact, model, notes, deleted
        Interface (attendant, paystation, unit)
            type (enum), model, provider, deleted
        --InterfaceTrigger (attendant, scanner, finger, remotescan)
        --InterfaceWashequipment
            qrcode, remote config
        --interfacewashequipmentplan
            service plan id
            relay name
            deleted
            price
            success message
            failmessage
        
    */

    return (
        <React.Fragment>
            {openAlert && <AlertDialog classes={classes}
                open={openAlert} 
                content={alertText}
                onConfirm={() => setOpenAlert(false)} />}
            <span style={{display:"inline-flex"}}>
            <Typography variant="h6" className={classes.header}>Equipment</Typography>
            <IconButton disabled={!canAdd()} onClick={() => _addNewEquipment()} ><Icon iconName={SupportedIcons.AddBox}></Icon></IconButton>
            </span>
            <Grid container direction="column" justify="flex-start" alignItems="stretch">
                <Grid item>
                    <Typography variant="caption" display="block">
                        Add all equipment at the location, even if EverWash does not interface with that equipment.  
                        Click on the name of the equipment below (if any) to see all interfaces that are configured.  Use the 'pencil' icon to edit the equipment or interface.
                    </Typography>
                </Grid>
                { equip.equipment.map(e => {
                    return ( <EquipmentDisplayItem 
                        classes={classes} 
                        item={e} 
                        onChange={(itm) => _EquipChange(itm)} 
                        onSave={() => _SaveEquipment()} 
                        onCancel={() => _CancelAddEquipment()}  
                        onSelect={() => highLightEquipment(e.id || 0)}
                        onDelete={_DeleteEquipment} /> )
                })}
            </Grid>
            <span style={{display:"inline-flex"}}>
            <Typography variant="h6" className={classes.header}>Interfaces</Typography>
            <IconButton disabled={!canAdd()} onClick={() => _addNewInterface()}><Icon iconName={SupportedIcons.AddBox}></Icon></IconButton>
            </span>
            <Grid container direction="column" justify="flex-start" alignItems="stretch">
                <Grid item>
                    <Typography variant="caption" display="block">
                        Add the interfaces (either EverWash installed devices, or existing paystation) through which EverWash can control the wash's equipment.  Click the name of the interface below (if any) to see which equipment are currently configured.  Click the 'pencil' icon to configure the interface.
                    </Typography>
                </Grid>
                {equip.interfaces.map(e => {
                    return ( <InterfaceDisplayItem 
                        classes={classes} 
                        item={e} 
                        manifest={equip} 
                        onChange={(itm)=>_InterfaceChange(itm)} 
                        onSave={()=>_SaveInterface()} 
                        onCancel={() => _CancelAddInterface()} 
                        onSelect={() => highLightInterface(e.id || 0)}
                        onDelete={_DeleteInterface} /> )
                })}
            </Grid>
        </React.Fragment>
    )
}

export default Equipment;
